import utils from '@/utils';
import objectToQuerystring from '@/utils/sfaas_temp/objectToQueryString';
import client from '@/api/client';
import { BASE_URL } from '@/constants';

export default {
	saveApprReason: ({ saveApprReason }) => {
		let queryStr = '';

		//onsole.log('값은뭐냐>>', saveApprReason);

		queryStr = objectToQuerystring({
			masterKey1: saveApprReason.masterKey1,
			masterKey2: saveApprReason.masterKey2,
			masterKey3: saveApprReason.masterKey3,
			masterKey4: saveApprReason.masterKey4,
			masterKey5: saveApprReason.masterKey5,
			apprState: saveApprReason.apprState,
			contents: saveApprReason.contents
		});

		//console.log('파라미터', queryStr);

		return client
			.post(`${BASE_URL}/comm/commpopup/compApprRsonPopup/v1/status/2/apiType/${saveApprReason.apiType}` + queryStr)
			.then(response => (response && response.data) || null)
			.catch(error => {
				throw error.response.data;
			});
	}
};
